module.exports = __webpack_public_path__ + "img/vuejs.afab989b.png";